import Vue from 'vue'
import axios from 'axios'

export function authenticate(email, password){
  return axios.post(process.env.OAUTH_URL, {
    email: email,
    password: password,
    grant_type: "password"
  })
}

export function me(){
  return Vue.axios.get('/v1/users/me');
}

export function completeLearningNewFeatures(){
  return Vue.axios.put(process.env.API_URL + '/v1/users/me/complete_learning_new_features')
}



// WEBPACK FOOTER //
// ./src/backend/auth.js